<template>
  <Modal @closeModal="close">

    <!-- header may or may not be removed -->
    <template slot="header">
      <div class="d-flex align-items-center justify-content-between">
        <h3>Export</h3>
        <div v-if="errors"  class="px12 cursor-pointer" @click="close">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </template>

    <!-- body needs to change according to exportData status update -->
    <template slot="body">
      <div class="d-flex flex-col align-items-center justify-content-between text-center" :class="errors ? 'error' : ''">
        <div class="d-flex flex-col align-items-center py-4">
          <Loader v-if="!errors && !exportFinished" class="h-40" />
          <span v-else>
            <i class="far text-xxl min-h-40" :class="[errors ? 'fa-exclamation-triangle' : 'fa-check-circle']"/>
          </span>
        </div>
        <h3 class="">
          <span v-if="errors">{{errors}}</span>
          <span v-else>{{$t(`export.${exportStateTranslation}`)}} {{ rows_received ? (': ' + rows_received + ' ' + $t('export.rows_received')) : ''}}</span>
        </h3>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '../modal';
import Loader from "../../components/loader.vue";
export default {
  name: "QueryExportModal",
  components: {
    Modal,
    Loader
  },
  props: {
    exportObj: {
      type: Object
    }
  },
  computed: {
    exportData() { return this.exportObj.data },
    exportState() { return this.exportData.state },
    exportStateTranslation() { return this.exportState || 'initiated' },
    exportFinished() { return this.exportData.state && this.exportData.state === 'finished' },
    rows_received() { return this.exportData.row_received > 0 ? this.exportData.row_received : 0},
    errors() { return this.exportObj.error  }
  },

  methods: {
    close() {
      if(!this.errors) return
      this.$store.commit('queryBuilder/query/EXPORT_QUERY_FAIL')
      this.$store.commit('queryBuilder/query/EXPORT_QUERY_BUSY', false)
    }
  }
}
</script>